import { IChat } from '../../../global';

export default (chat: IChat, userId: string) => {
  return chat.owner?.id === userId;
};
